import { apiRequest } from "../util/apiUtils";

export const faqList = async (params) => {
  try {
    const res = await apiRequest("get", `/post/list?`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqDetails = async (params) => {
  try {
    const res = await apiRequest("get", `post/detail/${params?.id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `post/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `post/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const faqOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `post/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
